function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "visible", "title", "onClose", "actions", "secondaryAction", "triggeredByRef"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import PropTypes from 'prop-types';
import React, { useRef, forwardRef, useEffect, useId, useState, useLayoutEffect } from 'react';
import { useFela } from 'react-fela';
import Box from '../box/index.js';
import Grid from '../grid/index.js';
import Text from '../text/index.js';
import FloatingActionButton from '../floatingActionButton/index.js';
import { IconClose } from '../icons/index.js';
var titleStyle = {
  borderBottomWidth: 1,
  borderBottomColor: 'border',
  borderBottomStyle: 'solid'
};
var actionBarStyle = {
  borderTopWidth: 1,
  borderTopColor: 'border',
  borderTopStyle: 'solid'
};
var closeStyle = {
  cursor: 'pointer'
};
var dialogStyle = function dialogStyle(_ref) {
  var visible = _ref.visible,
    theme = _ref.theme,
    title = _ref.title;
  return {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    padding: 0,
    border: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    display: visible ? 'flex' : 'none',
    backgroundColor: title ? theme.colors.background.primary : 'rgba(0, 0, 0, 0.3)',
    paddingRight: 'env(safe-area-inset-right)',
    paddingLeft: 'env(safe-area-inset-left)',
    paddingTop: 'env(safe-area-inset-top)',
    paddingBottom: 'env(safe-area-inset-bottom)',
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    '&::backdrop': {
      backgroundColor: 'transparent'
    },
    medium: {
      backgroundColor: 'rgba(0,0,0,0.3)'
    }
  };
};
var Modal = /*#__PURE__*/forwardRef(function (_ref2, userRef) {
  var children = _ref2.children,
    _ref2$visible = _ref2.visible,
    visible = _ref2$visible === void 0 ? false : _ref2$visible,
    title = _ref2.title,
    onClose = _ref2.onClose,
    actions = _ref2.actions,
    secondaryAction = _ref2.secondaryAction,
    triggeredByRef = _ref2.triggeredByRef,
    props = _objectWithoutProperties(_ref2, _excluded);
  var defaultDialogRef = useRef();
  var dialogContentRef = useRef();
  var dialogRef = userRef || defaultDialogRef;
  var _useFela = useFela(),
    theme = _useFela.theme,
    css = _useFela.css;
  var titleId = useId();
  var headerId = useId();
  var footerId = useId();
  var contentId = useId();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isScrollable = _useState2[0],
    setIsScrollable = _useState2[1];
  var handleClose = function handleClose() {
    // Restore focus to triggering element if provided
    if (triggeredByRef && triggeredByRef.current) {
      triggeredByRef.current.focus();
    }
    if (onClose) {
      onClose();
    }
  };
  useEffect(function () {
    var dialog = dialogRef.current;
    if (!dialog) return;
    if (visible) {
      dialog.showModal();
    } else {
      dialog.close();
    }
  }, [visible, dialogRef]);

  // Check scrollability
  useLayoutEffect(function () {
    if (!visible) return;
    var modalContent = dialogContentRef.current;
    if (!modalContent) return;
    var scrollable = modalContent.scrollHeight > modalContent.clientHeight;
    setIsScrollable(scrollable);
  }, [visible, children, dialogContentRef]);

  // Focus management
  useEffect(function () {
    if (!visible) return;
    var modalContent = dialogContentRef.current;
    if (!modalContent) return;
    requestAnimationFrame(function () {
      if (isScrollable) {
        modalContent.focus();
      } else {
        var firstInteractiveElement = modalContent.querySelector('input:not([type="hidden"]):not([disabled]), ' + 'textarea:not([disabled]), ' + 'select:not([disabled]), ' + 'button:not([disabled]), ' + 'a[href]:not([disabled]), ' + '[role="button"]:not([disabled]), ' + '[role="textbox"]:not([disabled]), ' + '[role="combobox"]:not([disabled]), ' + '[contenteditable="true"]:not([disabled]), ' + '[tabindex]:not([tabindex="-1"]):not([disabled])');
        if (firstInteractiveElement) {
          firstInteractiveElement.focus();
        }
      }
    });
  }, [visible, isScrollable]);
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React.createElement("dialog", {
    tabIndex: -1,
    ref: dialogRef,
    className: css(dialogStyle({
      theme: theme,
      visible: visible,
      title: title
    })),
    "aria-labelledby": title ? titleId : undefined,
    "aria-describedby": contentId,
    "data-test": props['data-test'],
    onClose: handleClose,
    onCancel: handleClose,
    onClick: function onClick(e) {
      // Close dialog when clicking on backdrop (dialog element itself)
      if (e.target === e.currentTarget) {
        handleClose();
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    bg: "background.primary",
    alignSelf: "center",
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    height: [title ? '100%' : 'auto',, 'auto'],
    maxHeight: [title ? '100%' : 'calc(100% - 16px)',, 'calc(100% - 64px)'],
    width: [title ? '100%' : 'calc(100% - 16px)',, 'auto'],
    maxWidth: ['100%',, title ? 800 : 520],
    minWidth: 240,
    marginVertical: [title ? 0 : 4,, 16],
    marginHorizontal: title ? 0 : 4,
    extend: {
      overflow: 'hidden',
      boxShadow: title ? 0 : '0 0 30px 0 rgba(0, 0, 0, 0.1)',
      borderRadius: title ? 0 : theme.tokens.cornersLarge,
      medium: {
        boxShadow: '0 0 30px 0 rgba(0, 0, 0, 0.1)',
        borderRadius: theme.tokens.cornersLarge
      }
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    id: headerId,
    columns: '1fr auto 1fr',
    extend: _objectSpread({
      padding: '16px',
      justifyItems: 'center',
      alignItems: 'center'
    }, title && titleStyle),
    areas: ['"secondaryHeader header closeButton"']
  }, secondaryAction && !Array.isArray(secondaryAction) && /*#__PURE__*/React.createElement(Box, {
    extend: {
      justifySelf: 'start',
      gridArea: 'secondaryHeader'
    }
  }, secondaryAction), /*#__PURE__*/React.createElement(Box, {
    extend: {
      gridArea: 'header'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    id: titleId,
    variant: "ash",
    subStyle: "emphasis",
    align: "center"
  }, title || ' ')), /*#__PURE__*/React.createElement(Box, {
    marginRight: [-2,, 0],
    extend: _objectSpread({
      justifySelf: 'end',
      gridArea: 'closeButton'
    }, closeStyle)
  }, /*#__PURE__*/React.createElement(FloatingActionButton, {
    intent: "function",
    "data-test": "close-modal",
    onClick: handleClose,
    icon: IconClose,
    label: "St\xE4ng f\xF6nster"
  }))), /*#__PURE__*/React.createElement(Box, {
    "data-id": "modal-content",
    id: contentId,
    ref: dialogContentRef,
    tabIndex: isScrollable ? 0 : -1,
    padding: [4,, 10],
    paddingTop: [title ? 4 : 0,, title ? 10 : 0],
    paddingBottom: 0,
    shrink: 1,
    grow: 1,
    extend: {
      overflow: 'auto',
      overscrollBehavior: 'contain'
    }
  }, children, /*#__PURE__*/React.createElement(Box, {
    marginBottom: [4,, 10]
  })), actions && Array.isArray(actions) && /*#__PURE__*/React.createElement(Box, {
    id: footerId,
    direction: ['column',, 'row'],
    paddingVertical: 6,
    paddingHorizontal: [6,, 10],
    width: "100%",
    space: 4,
    extend: actionBarStyle,
    justifyContent: actions.length > 1 ? 'space-between' : 'flex-end'
  }, actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(Box, {
      key: index,
      alignSelf: ['stretch',, 'flex-start']
    }, action);
  }))));
});
export default Modal;
Modal.displayName = 'Modal';
Modal.propTypes = {
  /** A list of actions rendered in the action bar. */
  actions: PropTypes.array,
  /** The content of the modal. */
  children: PropTypes.element,
  /** A listener that is called once clicked outside of the modal. */
  onClose: PropTypes.func,
  /** A secondary Action in the header of the modal. */
  secondaryAction: PropTypes.func,
  /** Sets the title of the modal. */
  title: PropTypes.string,
  /** A ref to the element that triggered the modal. Focus will be restored to this element when the modal closes. */
  triggeredByRef: PropTypes.object,
  /** Sets the visiblity of the modal. */
  visible: PropTypes.bool
};